var map = {
	"./bars-light.svg": "4631",
	"./chevron-down-solid.svg": "492b",
	"./long-arrow-left.svg": "ccec",
	"./long-arrow-right.svg": "8784",
	"./minus-regular.svg": "ccff",
	"./plus-regular.svg": "150c",
	"./search-regular.svg": "49db",
	"./shopping-cart.svg": "b15e",
	"./sort-down-solid.svg": "3229",
	"./times-regular.svg": "a919"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";